module.exports = __webpack_public_path__ + "img/step-2.05498b07.svg";